import axios, { AxiosRequestConfig } from 'axios';
import { Parent } from '../types/Parent';
import { DataResponse, PagedResponse } from '../types/api';

const URL = '/v2/parents';

class ParentService {
  static get(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Parent>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Parent>> {
    return axios.get(URL, config);
  }

  static patch(
    id: number,
    data: Partial<Parent>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Parent>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { ParentService };
